/** Русская форма слова «элемент» для счётчика. */
export const selectedItemsNoun = (count: number) => {
    const mod100 = count % 100;
    const mod10 = count % 10;
    if (mod100 >= 11 && mod100 <= 14) return 'элементов';
    if (mod10 === 1) return 'элемент';
    if (mod10 >= 2 && mod10 <= 4) return 'элемента';
    return 'элементов';
};
